<template>
    <div id="maintenanace">
        <h1 v-if="device == 'desktop'">{{ $t('maintenance') }}</h1>
        <h1 v-if="device != 'desktop'">{{ $t('maintenance_phone') }}</h1>
        <img src="https://e-rovinieta.ro/media/maintenance.jpg"> 
    </div>
</template>
<script>
export default {
    name: 'Maintenanace',
    data: function() {
        return {
            device: process.env.VUE_APP_DEVICE
        }
    },
}
</script>
<style lang="scss" scoped>
    #maintenanace {
        width: 100vw;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        text-align: center;
        padding: 0px 15px;

        h1 {
            font-size: 35px;

            @media only screen and (max-width: 768px) {
                font-size: 20px;
            }
        }
    
        img {
            width: 100%;
            max-width: 800px;
        }
    }
</style>
